const onFocus = (event) => {
  event.target.parentNode.classList.add('has-focus');
};

const onBlur = (event) => {
  event.target.parentNode.classList.remove('has-focus');
};

const init = () => {
  const inputs = document.querySelectorAll('[data-element="addon-input"]');
  const imgs = document.querySelectorAll('[data-element="addon-zoom"]');
  let isImageZoomed = false;

  const zoom = (event) => {
    isImageZoomed = !isImageZoomed;
    if (isImageZoomed) {
      event.target.classList.add('has-focus');
    } else if (!isImageZoomed) {
      event.target.classList.remove('has-focus');
    }
  };

  if (inputs) {
    inputs.forEach((input) => {
      input.addEventListener('focus', onFocus);
      input.addEventListener('blur', onBlur);
    });
  }

  if (imgs) {
    imgs.forEach((img) => {
      img.addEventListener('click', zoom);
    });
  }
};

init();
